import {
  createTask,
  CreateTaskData,
  getTargets,
  getTemplateList,
  GetTemplateList,
  getTemplateDetail,
  GetTemplateDetail,
  getEmailList,
  getAttCkList,
  getSecurityDevice,
  GetSecurityDevice,
  getCaseList,
  GetCaseList,
  saveCaseToTemplate,
  SaveCaseToTemplate,
  getCaseDetail,
  GetCaseDetail,
  getAllTemplateId,
  getAllCaseId,
  getAttackTypeList,
  getResourceTagList,
  getResourceIdsByTemplateIds,
  getTargetList,
  getAgentList,
  getEmailSendList,
} from '@/api/email-create-task'
import { getTaskGroups } from '@/api/account-center/task-management'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { t } from '@/i18n'

export const useGetTargets = () => {
  const { data, runAsync } = useRequest(getTargets, {
    onError(err: any) {
      Message.error(err?.msg || t('目标获取失败'))
    },
  })
  return [data?.data?.items || [], runAsync] as const
}

export const useGetEmailList = () => {
  const { data, runAsync: run } = useRequest(getEmailList, {
    onError(err: any) {
      Message.error(err?.msg || t('目标获取失败'))
    },
  })
  return [data?.data?.items || [], run] as const
}

export const useEmailCreateTask = () => {
  const { runAsync, loading } = useRequest((data: CreateTaskData) => createTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务创建失败'))
    },
  })
  return [runAsync, loading] as const
}

//创建任务ATTCK列表
export const useGetAttCkList = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getAttCkList(), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('ATT&CK列表获取失败'))
    },
  })
  return [run, data?.data?.items || [], loading] as const
}

// 获取任务分组
export const useTaskGroup = () => {
  const { runAsync: run, data } = useRequest(params => getTaskGroups(params), {
    manual: true,
    onError: (error: any) => {
      Message.error(error.msg || t('获取分组列表失败'))
    },
  })

  return [data?.data?.groups || [], run] as const
}

// 2.0.2

// 获取安全设备
export const useGetSecurityDevice = () => {
  const { runAsync } = useRequest((params: GetSecurityDevice) => getSecurityDevice(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全设备失败'))
    },
  })
  return [runAsync] as const
}

// 获取模板列表
export const useGetTemplateList = () => {
  const { runAsync, loading } = useRequest((params: GetTemplateList) => getTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取模板列表失败'))
    },
  })
  return [runAsync, loading] as const
}

// 获取关联用例列表
export const useGetCaseList = () => {
  const { runAsync, loading } = useRequest((params: GetCaseList) => getCaseList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取关联用例列表失败'))
    },
  })
  return [runAsync, loading] as const
}

// 保存已选择用例为模板
export const useSaveCaseToTemplate = () => {
  const { runAsync, loading } = useRequest(
    (params: SaveCaseToTemplate) => saveCaseToTemplate(params),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || t('保存模板失败'))
      },
    },
  )
  return [runAsync, loading] as const
}

// 获取用例详情
export const useGetCaseDetail = () => {
  const { data, runAsync, loading } = useRequest((params: GetCaseDetail) => getCaseDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例详情失败'))
    },
  })
  return [data?.data || {}, runAsync, loading] as const
}

// 获取所有模板id
export const useGetAllTemplateId = () => {
  const { data, runAsync } = useRequest((params: GetTemplateList) => getAllTemplateId(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取所有模板id失败'))
    },
  })
  return [runAsync] as const
}

// 获取所有用例id
export const useGetAllCaseId = () => {
  const { data, runAsync } = useRequest((params: GetCaseList) => getAllCaseId(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取所有用例id失败'))
    },
  })
  return [runAsync] as const
}

export const schedulerTypeMap = {
  scheduler_type_immediate: t('即时任务'),
  scheduler_type_reserve: t('定时任务'),
  scheduler_type_daily: t('每天'),
  scheduler_type_weekly: t('每周'),
  scheduler_type_monthly: t('每月'),
  scheduler_type_hourly: t('每小时'),
  scheduler_type_minutely: t('每分钟'),
}

// 获取攻击类型

export const useAttackTypeList = () => {
  const { data, runAsync } = useRequest(params => getAttackTypeList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取攻击类型失败'))
    },
  })
  return [data?.data?.attackTypeFilters || [], runAsync] as const
}

// 获取用例标签

export const useResourceTagList = () => {
  const { data, runAsync } = useRequest(params => getResourceTagList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取用例标签失败'))
    },
  })
  return [data?.data?.categoryList || [], runAsync] as const
}

// 根据templateIds获取resourceIds
export const useGetResourceIdsByTemplateIds = () => {
  const { data, runAsync } = useRequest(params => getResourceIdsByTemplateIds(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取资源id失败'))
    },
  })
  return [data?.data?.resourceIds || [], runAsync] as const
}

// 获取安全域列表（原目标邮箱）
export const useGetTargetList = () => {
  const { data, runAsync } = useRequest(params => getTargetList(params), {
    manual: false,
    onError(err: any) {
      Message.error(err?.msg || t('获取安全域列表失败'))
    },
  })
  return [data?.data?.areas || [], runAsync] as const
}

// 获取Agent列表
export const useGetAgentList = () => {
  const { runAsync } = useRequest(params => getAgentList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取Agent列表失败'))
    },
  })
  return [runAsync] as const
}

// 获取邮箱发送列表
export const useGetEmailSendList = () => {
  const { data, runAsync } = useRequest(() => getEmailSendList(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取邮箱发送列表失败'))
    },
  })
  return [data?.data?.emailUsers || [], runAsync] as const
}
